module.exports = __webpack_public_path__ + "img/lengku.9c5c7bc2.png";